module.exports = __webpack_public_path__ + "img/5.d9d75a54.jpg";